import { Sort } from '@opensearch-project/opensearch/api/_types/_common';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';
import { FieldCollapse } from '@opensearch-project/opensearch/api/_types/_core.search';

/**
 * On-sale filter whose `is_schedule_active` script runs in the given store's
 * timezone. Pass the selected/default store's `dispensary_time_zone`.
 */
export const buildOnSaleQueryFilter = (timeZone: string): QueryContainer => ({
  bool: {
    filter: [{ term: { isActive: true } }],
    should: [
      {
        range: {
          customOnSaleValue: { gte: 1024 },
        },
      },
      {
        bool: {
          filter: [
            {
              script: {
                script: {
                  source: "(doc['customOnSaleValue'].value & 4) == 4",
                },
              },
            },
            {
              nested: {
                path: 'customOnSaleSchedule',
                query: {
                  script: {
                    script: {
                      id: 'is_schedule_active',
                      params: {
                        time_zone: timeZone,
                      },
                    },
                  },
                },
              },
            },
          ],
        },
      },
    ],
    minimum_should_match: 1,
  },
});

export const DefaultSortingFilter: Sort = [
  {
    id: {
      order: 'asc',
    },
  },
];

export const CollapseParam: { collapse: FieldCollapse } = {
  collapse: {
    field: 'catalogParentId',
    inner_hits: {
      name: 'siblings',
      size: 5,
      _source: [
        'amount',
        'id',
        'slug',
        'name',
        'menuTitle',
        'oldSlug',
        'customMinPrice',
        'customSize',
        'productData',
        'unitOfMeasurement',
        'availableUnits',
        'isAboveThreshold',
        'category',
        'subtype',
      ],
    },
  },
};
